export default __webpack_public_path__ + "static/media/img2.83d73248.png";